// Close panel handler registered ONCE (outside turbolinks:load) to avoid duplicate listeners
document.addEventListener('click', (e) => {
  const closeTrigger = e.target.closest('.fab-panel-close') || e.target.closest('[data-action="close-chat-panel"]');
  if (closeTrigger) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (typeof window.closeFabPanel === 'function') {
      window.closeFabPanel();
    }
  }
}, true);

document.addEventListener('turbolinks:load', () => {
  const fabButton = document.querySelector('.fab-button');
  const actionButtons = document.querySelector('.fab-action-buttons');
  const closeButton = document.querySelector('.fab-close-button');

  const showActionButtons = () => {
    const overlay = document.querySelector('.fab-overlay');
    if (actionButtons && overlay) {
      actionButtons.classList.add('active');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  };

  const hideActionButtons = () => {
    const overlay = document.querySelector('.fab-overlay');
    if (actionButtons && overlay) {
      actionButtons.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  };

  const openPanel = () => {
    const overlay = document.querySelector('.fab-overlay');
    const sidePanel = document.querySelector('.fab-side-panel');
    if (overlay && sidePanel) {
      hideActionButtons();
      overlay.classList.add('active');
      sidePanel.classList.add('active');
      document.body.style.overflow = 'hidden';

      // Re-establish chat subscriptions when panel opens
      if (typeof window.reestablishChatSubscriptions === 'function') {
        window.reestablishChatSubscriptions();
      }
    }
  };

  const closeAll = () => {
    const overlay = document.querySelector('.fab-overlay');
    const sidePanel = document.querySelector('.fab-side-panel');
    const actionButtons = document.querySelector('.fab-action-buttons');
    if (overlay) overlay.classList.remove('active');
    if (sidePanel) sidePanel.classList.remove('active');
    if (actionButtons) actionButtons.classList.remove('active');
    document.body.style.overflow = '';
  };

  // Only show expandable menu when FAB is a plus button (e.g. when Ticketing is added)
  if (fabButton && !fabButton.classList.contains('fab-button--chat')) {
    fabButton.addEventListener('click', (e) => {
      e.stopPropagation();
      showActionButtons();
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.stopPropagation();
      hideActionButtons();
    });
  }

  const overlay = document.querySelector('.fab-overlay');
  if (overlay) {
    overlay.addEventListener('click', () => {
      closeAll();
    });
  }

  // Remove the previous visit's listener first, otherwise one Escape press runs the handler once per visit so far
  if (window.fabEscapeHandler) document.removeEventListener('keydown', window.fabEscapeHandler);
  window.fabEscapeHandler = (e) => {
    if (e.key === 'Escape') {
      const sidePanel = document.querySelector('.fab-side-panel');
      const actionButtons = document.querySelector('.fab-action-buttons');
      if (sidePanel && sidePanel.classList.contains('active')) {
        closeAll();
      } else if (actionButtons && actionButtons.classList.contains('active')) {
        hideActionButtons();
      }
    }
  };
  document.addEventListener('keydown', window.fabEscapeHandler);

  window.showFabActionButtons = showActionButtons;
  window.hideFabActionButtons = hideActionButtons;
  window.openFabPanel = openPanel;
  window.closeFabPanel = closeAll;
});

window.updateFabBadge = (count) => {
  const badge = document.querySelector('.fab-badge');
  if (badge) {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }
};

// --- Draggable FAB ---
(function() {
  const DRAG_THRESHOLD = 5;
  const STORAGE_KEY = 'fab_position';
  const EDGE_PAD = 8;

  function getHeaderHeight() {
    const nav = document.querySelector('nav, .navbar, header, .top-nav, .header-nav');
    if (!nav) return 0;
    const rect = nav.getBoundingClientRect();
    // Only count if it's at the top of the page (fixed/sticky header)
    return rect.top < 10 ? rect.bottom : 0;
  }

  let isDragging = false;
  let wasDragged = false;
  let startX, startY, origLeft, origTop;

  function getFab() {
    return document.querySelector('.floating-action-button');
  }

  function restorePosition() {
    const fab = getFab();
    if (!fab) return;
    try {
      const pos = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (pos) {
        const minY = getHeaderHeight() + EDGE_PAD;
        const maxX = window.innerWidth - fab.offsetWidth - EDGE_PAD;
        const maxY = window.innerHeight - fab.offsetHeight - EDGE_PAD;
        fab.style.right = 'auto';
        fab.style.bottom = 'auto';
        fab.style.left = Math.min(Math.max(EDGE_PAD, pos.left), maxX) + 'px';
        fab.style.top = Math.min(Math.max(minY, pos.top), maxY) + 'px';
      }
    } catch (e) {}
  }

  let pointerId = null;

  function onPointerDown(e) {
    const fab = getFab();
    if (!fab || !e.target.closest('.fab-button')) return;

    isDragging = false;
    wasDragged = false;
    pointerId = e.pointerId;
    const rect = fab.getBoundingClientRect();
    startX = e.clientX;
    startY = e.clientY;
    origLeft = rect.left;
    origTop = rect.top;

    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);
  }

  function onPointerMove(e) {
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;

    if (!isDragging && Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;

    if (!isDragging) {
      // First frame of drag — capture pointer and prevent default
      isDragging = true;
      wasDragged = true;
      const fab = getFab();
      if (fab) {
        try { fab.setPointerCapture(pointerId); } catch (_) {}
        fab.classList.add('fab-dragging');
      }
    }

    e.preventDefault();
    const fab = getFab();
    if (!fab) return;

    const minY = getHeaderHeight() + EDGE_PAD;
    const maxX = window.innerWidth - fab.offsetWidth - EDGE_PAD;
    const maxY = window.innerHeight - fab.offsetHeight - EDGE_PAD;
    fab.style.right = 'auto';
    fab.style.bottom = 'auto';
    fab.style.left = Math.min(Math.max(EDGE_PAD, origLeft + dx), maxX) + 'px';
    fab.style.top = Math.min(Math.max(minY, origTop + dy), maxY) + 'px';
  }

  function onPointerUp(e) {
    document.removeEventListener('pointermove', onPointerMove);
    document.removeEventListener('pointerup', onPointerUp);

    const fab = getFab();
    if (fab) {
      fab.classList.remove('fab-dragging');
      try { fab.releasePointerCapture(e.pointerId); } catch (_) {}
    }

    if (wasDragged && fab) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          left: parseInt(fab.style.left),
          top: parseInt(fab.style.top)
        }));
      } catch (e) {}
    }

    isDragging = false;
    pointerId = null;
  }

  // Suppress click only after a real drag so the panel doesn't open
  document.addEventListener('click', (e) => {
    if (wasDragged && e.target.closest('.floating-action-button')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      wasDragged = false;
      return false;
    }
  }, true);

  // Prevent native browser link-drag on the FAB anchor element
  document.addEventListener('dragstart', (e) => {
    if (e.target.closest('.floating-action-button')) e.preventDefault();
  });

  document.addEventListener('pointerdown', onPointerDown);
  document.addEventListener('turbolinks:load', restorePosition);
  restorePosition();
})();
